const MediaType = Object.freeze({
  IMAGE: 'Image',
  VIDEO: 'Video',
  AUDIO: 'Audio',
  LINK: 'Link',
  NO_MEDIA: 'NoMedia'
})
export default MediaType
export type MediaTypeStrings = typeof MediaType[keyof typeof MediaType]
// RESERVE BELOW
